import Row from "@Containers/components/Row";
import CountControl from "@Generic/controls/CountControl";
import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import useGetAmenitiesCurrency from "@CheckOrder/features/amenities/hooks/useGetAmenitiesCurrency";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import useCountAmenity from "@CheckOrder/features/amenities/features/countAmenity/features/list/hooks/useCountAmenity";
import {SetStateType} from "@/types/generic/SetState.type";
import IconTicketAmenity from "@Icons/ticket/amenities/IconTicketAmenity";
import {Colors} from "@Styles/Colors.style";

interface CountAmenityProps {
    countAmenity: CountAmenityType,
    selectedAmenities: Record<string, CountAmenitySelectedType>
    setSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
}

function CountAmenityHandler(props: CountAmenityProps) {
    const {
        countAmenity,
        selectedAmenities,
        setSelectedAmenities,
    } = props

    const {
        icon,
        priceInUserCurrency,
        translations: {
            title,
            description,
            label,
        },
    } = countAmenity

    const {sign} = useGetAmenitiesCurrency() || {}

    const {
        value,
        handleIncrement,
        handleDecrement,
    } = useCountAmenity(countAmenity, selectedAmenities, setSelectedAmenities)

    return (
        <>
            <h5 className="amenity-selector__title">
                {title}
            </h5>
            {!!description && (
                <p className="amenity-selector__description">
                    {description}
                </p>
            )}
            <div className={`count-amenity ${value ? "count-amenity__active" : ""}`}>
                <IconTicketAmenity
                    {...icon}
                    width="24"
                    height="24"
                    className="count-amenity__icon"
                    fill={value ? Colors.neutralDarkestColor : Colors.primaryColor}
                />
                <span className="gb--emphasize-default count-amenity__description">
                    {label}
                </span>
                <Row
                    gap
                    center
                    className="count-amenity__count-control"
                >
                    <CountControl
                        incrementControl={{
                            handle: handleIncrement,
                            className: "count-control__button",
                        }}
                        decrementControl={{
                            handle: handleDecrement,
                            className: "count-control__button",
                        }}
                        count={value}
                        countClassName="count-control__total"
                    />
                </Row>
                <div
                    className="count-amenity__price"
                >
                    {`${priceInUserCurrency} ${sign}`}
                </div>
            </div>
        </>
    )
}

export default CountAmenityHandler